export type EventTypeValue = 'account_launch_60' | 'account_launch_30' | 'special_event_30' | 'recurring_event';

export const EVENT_TYPE_OPTIONS: { label: string; value: EventTypeValue }[] = [
  { label: 'Account Launch 60', value: 'account_launch_60' },
  { label: 'Account Launch 30', value: 'account_launch_30' },
  { label: 'Special Event 30', value: 'special_event_30' },
  { label: 'Recurring Event', value: 'recurring_event' }
];

export const eventTypeLabel = (value?: string | null) => {
  const opt = EVENT_TYPE_OPTIONS.find((o: { value: string }) => o.value === value);
  return opt ? opt.label : 'Unknown';
};
